module.exports = __webpack_public_path__ + "img/w4-b2.80608db2.jpg";